<template>
  <div>
    <div class="top_tit">
      <div class="line"></div>
      <p>{{ photo.Name }}</p>
    </div>
    <div class="bottom_content">
      <van-swipe
        v-if="photo.Materials.length > '0'"
        class="my-swipe"
        indicator-color="#b57e48"
        :show-indicators="false"
        @change="(i) => onChange(i)"
      >
        <van-swipe-item
          v-for="(item, index) in photo.Materials"
          :key="item.materialId"
        >
          <van-image
            fit="contain"
            :src="api.FileHost + item.MaterialUrl"
            @click.stop="showImg(index)"
          />
          <div class="bottom_yy"></div>
          <div class="xq">
            <p class="ms">
              {{ item.MaterialName }}
            </p>
          </div>
        </van-swipe-item>
      </van-swipe>
      <div v-if="photo.Materials.length > '0'" class="custom-indicator">
        <ul>
          <li
            v-for="(e, i) in photo.Materials"
            :key="i + 'j'"
            :class="i === photo.lbIndex ? 'active' : ''"
          ></li>
        </ul>
      </div>

      <van-empty
        v-if="photo.Materials.length == '0'"
        description="暂无图片"
        image-size="40"
      />
    </div>
  </div>
</template>

<script>
  import api from '@/api'
  import { onMounted, ref, watch } from 'vue'
  import { ImagePreview, Toast } from 'vant'
  import store from '@/store'
  export default {
    props: {
      // eslint-disable-next-line vue/require-default-prop
      photo: {
        type: Object,
      },
    },
    setup(props) {
      const videoArr = ref([])
      onMounted(() => {
        props.photo.lbIndex = 0
      })
      //时间转换
      const dataZh = (data, time) => {
        let newData = time.split('')
        let mouth = newData.splice(4, 2)
        let day = newData.splice(4, 2)
        let strmouth = mouth[0] + mouth[1] + ''
        let strday = day[0] + day[1] + ''
        //console.log('strmouth :>> ', strmouth)
        //console.log('strday :>> ', strday)
        data.mouth = strmouth
        data.day = strday
        //let mouth =
      }
      const onChange = (i) => {
        props.photo.lbIndex = i
      }

      const showImg = (index) => {
        const arr = []
        props.photo.Materials.forEach((item) => {
          arr.push(api.FileHost + item.MaterialUrl)
        })
        ImagePreview({
          images: arr,
          startPosition: index,
          showIndex: false,
          showIndicators: true,
          overlayStyle: {
            background: '#000',
          },
          //closeable: true,
        })
      }

      return {
        onChange,
        videoArr,
        api,
        showImg,
      }
    },
  }
</script>

<style lang="scss" scoped>
  .my-swipe .van-swipe-item {
    color: #fff;
    font-size: 20px;
    line-height: 150px;
    text-align: center;
    background-color: #39a9ed;
  }
  .custom-indicator {
    margin-top: 10px;
    ul {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      li {
        width: 4px;
        height: 4px;
        margin: 0 2px;
        background: #dbdbdd;
        border-radius: 50%;
      }
      li.active {
        width: 16px;
        height: 4px;
        background: #b57e48;
        border-radius: 5px;
      }
    }
  }
  .bottom_content {
    position: relative;
    padding: 15px;
    .bottom_yy {
      width: 100%;
      height: 38px;
      position: absolute;
      bottom: 0;
      left: 0;
      background: linear-gradient(
        180deg,
        transparent 0%,
        rgba(0, 0, 0, 0.6) 100%
      );
    }
    .xq {
      position: absolute;
      width: 100%;
      height: 22px;
      display: flex;
      flex-direction: row;
      justify-content: flex-starts;
      align-items: center;
      padding: 0 10px;
      box-sizing: border-box;
      bottom: 5px;
      z-index: 6;
      overflow: hidden;
      .ms {
        width: 100%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #f7f7fa;
        font-size: 12px;
        margin-left: 3%;
        text-align: left;
      }
      .data {
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #f7f7fa;
        font-size: 12px;
        span {
          font-size: 16px;
        }
      }
      .gk {
        font-size: 12px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #dbdbdd;
      }
    }
  }
  .van-swipe {
    border-radius: 9px !important;
    width: 100% !important;
    height: 170px !important;
  }
  .van-swipe-item {
    img {
      width: 100%;
      height: 100%;
    }
  }
  .van-swipe__indicator {
    width: 11px !important;
    height: 5px !important;
  }
  @media screen and (min-width: 1px) and (max-width: 335px) {
    .bottom_content .xq .ms {
      margin-right: 10%;
      width: 62%;
    }
  }

  @media screen and (min-width: 500px) and (max-width: 700px) {
    .bottom_content .xq .ms {
      margin-right: 10%;
      width: 78%;
    }
  }
  @media screen and (min-width: 701px) and (max-width: 900px) {
    .bottom_content .xq .ms {
      margin-right: 25%;
      width: 68%;
    }
  }
  @media screen and (min-width: 901px) {
    .bottom_content .xq .ms {
      margin-right: 11%;
      width: 77%;
    }
  }
</style>
